import { useCallback, useEffect, useState } from "react";
import { KmsTypePresenter, KmsTypeSchedulingTimeInterval } from "@kaltura/mediaspace-shared-types";
import { baseUrl, postKmsData } from "@kaltura/mediaspace-shared-utils";

export type UserSessionsFetcher = (userIds: string[]) => Promise<Record<string, KmsTypeSchedulingTimeInterval[]>>;

export const useCreateUserSessionsFetcher = (): UserSessionsFetcher =>
    useCallback((userIds: string[]) => postKmsData(baseUrl + "/grouppage/index/live-sessions", { userIds }), []);

export const useLoadUserSessions = (users: KmsTypePresenter[], fetchSessions: UserSessionsFetcher) => {
    const [sessionsMap, setSessionsMap] = useState<Record<string, KmsTypeSchedulingTimeInterval[]>>({});

    useEffect(() => {
        const userIds = users.map(({ id }) => id);
        if (userIds.length) {
            fetchSessions(userIds)
                .then(setSessionsMap)
                .catch((error) => {
                    console.error("Failed to fetch sessions for users", userIds, error);
                    setSessionsMap({});
                });
        }
        else {
            setSessionsMap({});
        }
    }, [users, fetchSessions]);

    return sessionsMap;
};
